// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.fixed-menu-content {
    position: fixed !important;
    z-index: 1000 !important;
    overscroll-behavior: contain;
}
`, "",{"version":3,"sources":["webpack://./components/widgets/fDropdown/fDropdown.component.vue"],"names":[],"mappings":";AAGA;IACA,0BAAA;IACA,wBAAA;IACA,4BAAA;AACA","sourcesContent":["<script lang=\"ts\" src=\"./fDropdown.client\"></script>\n<template lang=\"pug\" src=\"./fDropdown.template\"></template>\n<style>\n.fixed-menu-content {\n    position: fixed !important;\n    z-index: 1000 !important;\n    overscroll-behavior: contain;\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
